<template>
  <div :class="{ 'mb-9': ((roleInSpace == 'space_admin' || roleInSpace == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || roleInSpace == 'space_admin' && subscriptionEnds || (role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')) }">
    <AlertMessages
      v-if="alertValue"  
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <SystemBarTopTrial v-if="(roleInSpace == 'space_admin' || roleInSpace == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial'"/>
    <SystemBarTopCancelSubscription v-if="roleInSpace == 'space_admin' && subscriptionEnds"/>
    <SystemBarTopPaymentFailed v-if="roleInSpace == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"/>
    <v-app-bar
      app
      clipped-left
      elevation="0"
      outlined
      v-if="!loadingData"
    > 
   
      <v-toolbar-title class="ml-n3">
       <router-link
          v-if="!mobile()"
          to="/"
        >
          <v-img
            v-if="logo == null"
            data-testid="logo-space"
            src="../assets/rtplogo.svg"
            max-height="40"
            :max-width="mobile() ? '40' : '150' "
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="logo"
            max-height="40"
            :max-width="mobile() ? '40' : '150' "
            class="d-none d-sm-block mx-4 justify-center"
            contain
            position="top left"
          />
        </router-link>
         <router-link
         v-else
          to="/"
        >
          <v-img
            v-if="icon == null"
            data-testid="logo-space"
            src="../assets/rtpicon.png"
            max-height="40"
            :max-width="mobile() ? '40' : '40' "
            class="justify-center mx-4"
            contain
            position="top left"
          />
          <v-img
            v-else
            data-testid="logo-space"
            :src="icon"
            max-height="40"
            :max-width="mobile() ? '40' : '40' "
            class="justify-center mx-4"
            contain
            position="top left"
          />
        </router-link>
      </v-toolbar-title>
       <v-divider
        vertical
        ></v-divider>
      <h3
        v-if="!mobile()"
        class="pl-6 no-break activity-title-edit"
      >
        <v-clamp
          autoresize
          :max-lines="2"
        >
          {{ categoryTitle }}
        </v-clamp>
      </h3>
      <h4
        v-if="mobile()"
        style="font-size:14px"
        class="pl-3 no-break"
      >
        <v-clamp
          autoresize
          :max-lines="1"
        >
          {{ categoryTitle }}
        </v-clamp>
      </h4>
      



    </v-app-bar>
  </div>
</template>

<script>
import {eventBus} from '../eventbus'
import VClamp from 'vue-clamp';
import { getHubCategory } from '../api/hubApi'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import i18n from '../plugins/i18n'
import AlertMessages  from './AlertMessages'
import SystemBarTopTrial from '../components/SystemBarTopTrial';
import SystemBarTopCancelSubscription from '../components/SystemBarTopCancelSubscription'
import SystemBarTopPaymentFailed from '../components/SystemBarTopPaymentFailed'

export default {
    components: {
        VClamp,
        AlertMessages,
        SystemBarTopTrial,
        SystemBarTopCancelSubscription,
        SystemBarTopPaymentFailed,
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            valid: true,
            isAuth: window.$cookies.get("token")? true: false,
            categoryTitle: '',
            spaceId: window.$cookies.get('space_id'),
            space: window.location.host.split('.')[0],
            subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            icon: localStorage.space ? JSON.parse(localStorage.space).icon : null,
            idps: localStorage.space ? JSON.parse(localStorage.space).idps : [],
            categoryId: this.$route.params.categoryId,
            entityType: "hub",
            alertMsg: '',
            alertType: '',
            alertValue:false,
            role:'',
            loadingData: false,
            roleInSpace: localStorage.space ? JSON.parse(localStorage.space).role : null,
        }
    },
    computed:{
      productPlan() {
          return this.$store.state.productPlan
      }
    },
    async created(){
        eventBus.$on('setHubCategoryTitle',(data)=>{
            this.categoryTitle = data
        })
        this.loadingData = true

        this.loadingData = false 
    },
    beforeDestroy() {
        eventBus.$off('setHubCategoryTitle')
    },
    methods:{
        async getHubCategory(){
            try {
                const response = await getHubCategory(this.categoryId)
                if(response.status == 200) {
                    this.categoryTitle = response.data.data.attributes.title

                }  
            } catch (e) {
                if(e.response){
                  this.alertValue = true
                  this.alertType = 'error'
                  this.alertMsg =  i18n.t('serverError')
                } 
            }
        },
    }
}
</script>

